import { Tenant } from "./tenant";
import {Organization} from "./organization";

export class ApplicationSubscription {
  name: string;
  description: string;
  subscriptionType: string;
  appliedTo: string;
  tenant: Tenant;
  protocol: string;
  protocolConfig: string;
  organization: Organization;
  active: boolean;
}
